import React from "react";
import { Link, Navigate } from "react-router-dom";
import useAuth from "./hooks/useAuth"; // adjust path if needed

const NotFound = () => {
  const { role } = useAuth();

  // Option 1: Immediate Redirect for MSIL users:
  if (role === "MSIL") {
    return <Navigate to="/AdminHome" replace />;
  }

  // Option 2: Show page with link depending on role (comment out above if you want this):
  /*
  const homeLink = role === "MSIL" ? "/AdminHome" : "/home";
  */

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>

      {/* Use immediate redirect OR just link depending on UX preference */}
      <Link to="/home" style={{ textDecoration: "none", color: "blue" }}>
        Go Back Home
      </Link>
    </div>
  );
};

export default NotFound;
  